<template>
  <v-content class="grey lighten-3">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>
  export default {
    name: 'CoreView',
    metaInfo () {
      return {
        title: 'Vuetify Material Dashboard by CreativeTim',
      }
    },
  }
</script>
